/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Split_Event_Aria_LabelInputs */

const en_timeline_split_event_aria_label = /** @type {(inputs: Timeline_Split_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split Event`)
};

const fr_timeline_split_event_aria_label = /** @type {(inputs: Timeline_Split_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diviser l'evenement`)
};

const de_timeline_split_event_aria_label = /** @type {(inputs: Timeline_Split_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split Event`)
};

const it_timeline_split_event_aria_label = /** @type {(inputs: Timeline_Split_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento diviso`)
};

const ru_timeline_split_event_aria_label = /** @type {(inputs: Timeline_Split_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разделенное событие`)
};

const es_timeline_split_event_aria_label = /** @type {(inputs: Timeline_Split_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento dividido`)
};

const zh_cn2_timeline_split_event_aria_label = /** @type {(inputs: Timeline_Split_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分裂事件`)
};

const ja_timeline_split_event_aria_label = /** @type {(inputs: Timeline_Split_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分割イベント`)
};

const hi_timeline_split_event_aria_label = /** @type {(inputs: Timeline_Split_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विभाजन घटना`)
};

const pt_pt2_timeline_split_event_aria_label = /** @type {(inputs: Timeline_Split_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento dividido`)
};

/**
* | output |
* | --- |
* | "Split Event" |
*
* @param {Timeline_Split_Event_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_split_event_aria_label = /** @type {((inputs?: Timeline_Split_Event_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Split_Event_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_split_event_aria_label(inputs)
	if (locale === "de") return de_timeline_split_event_aria_label(inputs)
	if (locale === "it") return it_timeline_split_event_aria_label(inputs)
	if (locale === "ru") return ru_timeline_split_event_aria_label(inputs)
	if (locale === "es") return es_timeline_split_event_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_split_event_aria_label(inputs)
	if (locale === "ja") return ja_timeline_split_event_aria_label(inputs)
	if (locale === "hi") return hi_timeline_split_event_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_split_event_aria_label(inputs)
	return en_timeline_split_event_aria_label(inputs)
});